"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconChevronUp', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M7.29324 5.29325C7.68424 4.90225 8.31624 4.90225 8.70724 5.29325L12.7072 9.29325C13.0982 9.68425 13.0982 10.3163 12.7072 10.7073C12.3162 11.0983 11.6842 11.0983 11.2932 10.7073L8.00024 7.41425L4.70724 10.7073C4.51224 10.9023 4.25624 11.0002 4.00024 11.0002C3.74424 11.0002 3.48824 10.9023 3.29324 10.7073C2.90224 10.3163 2.90224 9.68425 3.29324 9.29325L7.29324 5.29325Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M16.7072 12.2933L10.7073 6.29325C10.3163 5.90225 9.68425 5.90225 9.29325 6.29325L3.29325 12.2933C2.90225 12.6843 2.90225 13.3163 3.29325 13.7073C3.68425 14.0983 4.31625 14.0983 4.70725 13.7073L10.0002 8.41425L15.2933 13.7073C15.4883 13.9023 15.7442 14.0002 16.0002 14.0002C16.2562 14.0002 16.5122 13.9023 16.7072 13.7073C17.0982 13.3163 17.0982 12.6843 16.7072 12.2933'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M20.0487 14.7519L12.8487 7.5519C12.3795 7.0827 11.6211 7.0827 11.1519 7.5519L3.95188 14.7519C3.48268 15.2211 3.48268 15.9795 3.95188 16.4487C4.42108 16.9179 5.17948 16.9179 5.64868 16.4487L12.0003 10.0971L18.3519 16.4487C18.5859 16.6827 18.8931 16.8003 19.2003 16.8003C19.5075 16.8003 19.8147 16.6827 20.0487 16.4487C20.5179 15.9795 20.5179 15.2211 20.0487 14.7519'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M26.7316 19.6692L17.1316 10.0692C16.506 9.44359 15.4948 9.44359 14.8692 10.0692L5.26919 19.6692C4.64359 20.2948 4.64359 21.306 5.26919 21.9316C5.89479 22.5572 6.90599 22.5572 7.53159 21.9316L16.0004 13.4628L24.4692 21.9316C24.7812 22.2436 25.1908 22.4004 25.6004 22.4004C26.01 22.4004 26.4196 22.2436 26.7316 21.9316C27.3572 21.306 27.3572 20.2948 26.7316 19.6692'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;